import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.p5g().u51() : headers;
  return DelegatedCall().l5i(_this__u8e3s4.k5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.l5i(client, originCall, responseContent, responseHeaders);
      }
      static l5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.p5g().u51() : responseHeaders;
        var $this = this.m5i(client);
        $this.m5g_1 = new (DelegatedRequest())($this, originCall.n5i());
        $this.n5g_1 = new (DelegatedResponse())($this, originCall.p5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.s5i_1 = origin;
        this.t5i_1 = call;
      }
      u5i() {
        return this.t5i_1;
      }
      bw() {
        return this.s5i_1.bw();
      }
      v5i() {
        return this.s5i_1.v5i();
      }
      w5i() {
        return this.s5i_1.w5i();
      }
      o5i() {
        return this.s5i_1.o5i();
      }
      z2n() {
        return this.s5i_1.z2n();
      }
      u51() {
        return this.s5i_1.u51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.u51() : headers;
        super();
        this.x5i_1 = call;
        this.y5i_1 = origin;
        this.z5i_1 = content;
        this.a5j_1 = headers;
        this.b5j_1 = this.y5i_1.bw();
      }
      u5i() {
        return this.x5i_1;
      }
      u51() {
        return this.a5j_1;
      }
      c5j() {
        return this.z5i_1(this.y5i_1);
      }
      bw() {
        return this.b5j_1;
      }
      d5j() {
        return this.y5i_1.d5j();
      }
      e5j() {
        return this.y5i_1.e5j();
      }
      f5j() {
        return this.y5i_1.f5j();
      }
      g5j() {
        return this.y5i_1.g5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
